import { colors } from '../../../../themes/theme'

// Fallback color for blueprints whose `tagGroupId` does not resolve against
// the live `tag-groups/list` payload (orphan data). Sourced from the central
// theme palette (`colors.tagGroupFallback`); kept as a named export so consumers
// can override it at the call site.
export const DEFAULT_TAG_GROUP_COLOR = colors.tagGroupFallback

// Minimal shape of the bits of `TagGroup` the catalogue needs. Keeps the tree
// builders de-coupled from the full RTK Query response type so we can pass in
// either the live data or a fixture.
export interface TagGroupInfo {
  id: string
  name: string
  colorHex: string
  order?: number
}
